import { useCallback, useMemo } from 'react'

import { applyPageTitlePrefix, browsePageTitle } from '@/shared/lib/page-title-prefix'
import { useSiteBrand } from './useSiteBrand'

/** 租户站点配置的模块页主标题品牌前缀(来自 site.brand.page_title_prefix) */
export function usePageTitle() {
  const { site } = useSiteBrand()
  const prefix = useMemo(() => site.page_title_prefix?.trim() ?? '', [site.page_title_prefix])

  const withPrefix = useCallback(
    (title: string) => applyPageTitlePrefix(prefix, title),
    [prefix],
  )

  const browse = useCallback(
    (moduleTitle: string, browseLabel: string) => browsePageTitle(prefix, moduleTitle, browseLabel),
    [prefix],
  )

  return { prefix, withPrefix, browse }
}
